<template>
  <v-app class="myFont">
    <v-app-bar
      app
      color="#f6f6f6"
      class="d-print-none"
      v-if="$store.state.barActive"
    >
      <v-app-bar-nav-icon v-if="authenticate" @click="active = !active"></v-app-bar-nav-icon>

      <div class="d-flex align-center" style="color: #64625e;">
        <img src="https://festyapp.com/logo.png" alt="Logo Festy" width="100" style="vertical-align: middle;">
      </div>

      <v-menu
        offset-y
        tile
        :close-on-content-click="true"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left small>mdi-translate</v-icon> <strong>{{ $i18n.locale }}</strong> <v-icon v-if="attrs['aria-expanded'] == 'true'">mdi-chevron-up</v-icon> <v-icon v-else>mdi-chevron-down</v-icon> 
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, index) in lenguages" :key="index"
            @click="changeLanguaje(item.id)"
          >
            <v-list-item-title>
            <img :src="item.image" alt="" style="vertical-align: middle;"> <span style="vertical-align: middle;">{{item.name}}</span>
            </v-list-item-title>
          </v-list-item>

        </v-list>
      </v-menu>

      <v-spacer></v-spacer>

      <v-btn
        v-if="authenticate"
        to="/stores"
        text
        @click.stop="active = false"
        class="d-none d-sm-flex"
      >
        <v-icon>mdi-view-list</v-icon>
        <span class="ml-2">{{ $t('select_bussines') }}</span>
      </v-btn>

      <v-btn
        v-if="authenticate && $route.params.store_id"
        :to="`/tomahawk/${$route.params.store_id}`"
        text
        @click.stop="active = false"
        class="d-none d-sm-flex"
      >
        <v-icon>mdi-clock-fast</v-icon>
        <span class="ml-2">{{$t('see_orders')}}</span>
      </v-btn>

      <v-btn
        v-if="authenticate && $route.params.store_id"
        :to="`/mystore/${$route.params.store_id}`"
        text
        @click.stop="active = false"
        class="d-none d-sm-flex"
      >
        <v-icon>mdi-storefront</v-icon>
        <span class="ml-2">{{$t('my_business')}}</span>
      </v-btn>

      <v-btn
        v-if="authenticate"
        @click="logOut()"
        text
        class="d-none d-sm-flex"
      >
        <v-icon color="red">mdi-logout</v-icon>
        <span class="mr-2" style="color: red;">{{ $t('log_out') }}</span>
      </v-btn>

      <!--<v-btn
        class="d-none d-sm-flex"
        href="https://festyapp.com/"
        target="_blank"
        text
      >
        <span class="mr-2" style="color: green;">FestyApp</span>
        <v-icon color="green">mdi-android</v-icon>
      </v-btn>-->
    </v-app-bar>
    
    <v-navigation-drawer
      v-model="active"
      app
      temporary
    >
      <v-list-item>
        <v-list-item-avatar>
          <v-img :src="require('./assets/user.png')"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-if="authenticate">{{authenticate.attributes.name}}</v-list-item-title>
          <v-list-item-title v-else> Falso positivo </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense v-if="$store.state.menuOptions">

        <v-list-item to="/stores" @click.stop="active = false">
          <v-list-item-icon>
            <v-icon>mdi-view-list</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t('select_bussines') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isUserLoggedIn() && isMerchantIdDefined()" :to="`/tomahawk/${getMerchantId()}`" @click.stop="changeActiveToFalse()">
          <v-list-item-icon>
            <v-icon>mdi-clock-fast</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{$t('see_orders')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

         <v-list-item v-if="isUserLoggedIn() && isMerchantIdDefined()" :to="`/orders-delivered/${getMerchantId()}`" @click.stop="changeActiveToFalse()">
          <v-list-item-icon>
            <v-icon>mdi-text-box-check</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{$t('see_orders_delivered')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isUserLoggedIn() && isMerchantIdDefined()" :to="`/mystore/${getMerchantId()}`" @click.stop="changeActiveToFalse()">
          <v-list-item-icon>
            <v-icon>mdi-storefront</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{$t('my_business')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isUserLoggedIn() && isMerchantIdDefined()" :to="`/customers/${getMerchantId()}`" @click.stop="changeActiveToFalse()">
          <v-list-item-icon>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{$t('my_customers')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isUserLoggedIn() && isMerchantIdDefined()" :to="`/products/${getMerchantId()}`" @click.stop="changeActiveToFalse()">
          <v-list-item-icon>
            <v-icon>mdi-food</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{$t('my_products')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isUserLoggedIn() && isMerchantIdDefined()" :to="`/categories/${getMerchantId()}`" @click.stop="changeActiveToFalse()">
          <v-list-item-icon>
            <v-icon>mdi-tag-multiple</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{$t('see_categories')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isUserLoggedIn() && isMerchantIdDefined()" :to="`/banners/${getMerchantId()}`" @click.stop="changeActiveToFalse()">
          <v-list-item-icon>
            <v-icon>mdi-folder-multiple-image</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t("see_banners") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isUserLoggedIn() && isMerchantIdDefined()" :to="`/reports/${getMerchantId()}`" @click.stop="changeActiveToFalse()">
          <v-list-item-icon>
            <v-icon>mdi-chart-bar</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{$t('see_reports')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isUserLoggedIn() && isMerchantIdDefined()" :to="`/mystore-invoices/${getMerchantId()}`" @click.stop="changeActiveToFalse()">
          <v-list-item-icon>
            <v-icon>mdi-receipt</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{$t('see_invoices')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isUserLoggedIn() && isMerchantIdDefined()" :to="`/riders/${getMerchantId()}`" @click.stop="changeActiveToFalse()">
          <v-list-item-icon>
            <v-icon>mdi-bike-fast</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{$t('my_riders')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!--<v-list-item v-if="isUserLoggedIn() && isMerchantIdDefined()" :to="`/printers/${getMerchantId()}`" @click.stop="changeActiveToFalse()">
          <v-list-item-icon>
            <v-icon>mdi-printer-wireless</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Impresora</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

         <v-list-item v-if="isUserLoggedIn() && isMerchantIdDefined()" :to="`/me/${getMerchantId()}`" @click.stop="changeActiveToFalse()" target="_blank">
          <v-list-item-icon>
            <v-icon>mdi-store-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Perfil del negocio</v-list-item-title>
          </v-list-item-content>
        </v-list-item>-->

        <v-list-item v-if="isUserLoggedIn() && isMerchantIdDefined()" :to="`/config/schedule/${getMerchantId()}`" @click.stop="changeActiveToFalse()">
          <v-list-item-icon>
            <v-icon>mdi-calendar-arrow-right</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{$t('see_opening_hours')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-for="(item, index) in $store.state.menuOptions" :key="index" :to="item.url" @click.stop="changeActiveToFalse()">
          <v-list-item-icon>
            <v-icon>mdi-{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          @click="logOut()"
          @click.stop="active = false"
          v-if="authenticate"
        >
          <v-list-item-icon>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{$t('log_out')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>

    <v-content>
      <router-view :key="$route.fullPath"></router-view>
    </v-content>

    <vue-snotify></vue-snotify>

     <audio id="alert_new_order" controls style="display:none;">
      <source :src="require('./assets/alert.mp3')" type="audio/mpeg">
        Your browser does not support the audio element.
    </audio>

    <audio id="alert_change_status" controls style="display:none;">
      <source :src="require('./assets/alert.mp3')" type="audio/mpeg">
        Your browser does not support the audio element.
    </audio>

    <v-snackbar bottom right :value="updateExists" :timeout="-1" color="primary">
      Actualización disponible
      <v-btn text @click="refreshApp()">
        Refrescar
      </v-btn>
    </v-snackbar>

  </v-app>
</template>

<script>
import Parse from 'parse'
import update from './mixins/update.js'

export default {
  name: 'App',

  components: {
   
  },

  mixins: [update],

  data: () => ({
    authenticate: Parse.User.current(),
    active: false,
    lenguages: [
      { id: 'en', name: 'English', image: 'https://www.countryflags.io/us/flat/32.png'},
      { id: 'es', name: 'Español', image: 'https://www.countryflags.io/co/flat/32.png'},
    ],
  }),

  mounted() {
    this.$store.state.barActive = true
    this.changeLanguaje(this.$i18n.locale)
  },

  methods: {
    logOut() {
      /* eslint-disable */
      OneSignal.push(function() {
        OneSignal.removeExternalUserId();
      });
      Parse.User.logOut();
      window.location.reload()
    },

    isUserLoggedIn() {
      return this.authenticate && this.authenticate.id !== undefined && this.authenticate.id !== ''
    },

    isMerchantIdDefined() {
      return this.$route.params.store_id !== undefined && this.$route.params.store_id !== ''
    },

    getMerchantId() {
      return this.$route.params.store_id
    },

    changeActiveToFalse() {
      this.active = false
    },

    changeLanguaje(leng){
      this.$i18n.locale = leng
      this.$moment.locale(leng)
    }
  },
};
</script>

<style lang="scss">
@import "~vue-snotify/styles/material";
</style>

<style lang="css">

  .myFont {
    font-family: 'Quicksand' !important;
  }

  .swal-modal {
      font-family: Helvetica Neue, Arial, sans-serif;
  }

</style>